
<div class="modal-header" translate>Creating from {{fileTemplate.name}}</div>
<form class="modal-body" #form="ngForm">
  <div class="form-group">
    <label translate for="mediaCreateFromTemplateCreateModal-name">Name</label>
    <input class="form-control" type="text" required autofocus [(ngModel)]="name" name="name" (keydown.enter)="form.form.valid &amp;&amp; create()" id="mediaCreateFromTemplateCreateModal-name">
  </div>
  <div class="form-group" *ngIf="fileTemplate.file.isDir &amp;&amp; root.customFields!.length &gt; 0">
    <label translate>Custom fields</label>
    <custom-field-row *ngFor="let field of root.customFields" [(ngModel)]="customFieldValues[field.name]" [disabled]="field.nonUserEditable" name="field-{{field.name}}" [field]="field"></custom-field-row>
  </div>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="create()" [disabled]="!form.form.valid"><i class="far fa-check"></i><span translate>Create</span></button>
  <button class="btn btn-outline-secondary" (click)="cancel()"><span translate>Cancel</span></button>
</div>